module.exports = __webpack_public_path__ + "img/Referidos-Card.8f6585d8.svg";